import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SaveWindowDataContext from '../contexts/SaveWindowDataContext';
import FormUpdatedContext from '../contexts/FormUpdatedContext';
import { useLocation } from 'react-router';
import { selectShowDashboardWorkQueue } from '../redux/reducers/role';
import { selectWorkQueueListData } from '../redux/reducers/WorkQueueList';
import { postWqActivity } from '../redux/reducers/WorkQueue';

export const useSaveWindow = () => {
  const { triggerSaveByLabel } = useContext(SaveWindowDataContext);
  const { removeFormCode } = useContext(FormUpdatedContext);
  const showDashboardWorkQueue = useSelector(selectShowDashboardWorkQueue);
  const workQueueListData = useSelector(selectWorkQueueListData);
  const dispatch = useDispatch();
  const location = useLocation();
  const roleData = useSelector(({ role }) => role.roleData);

  const saveWindow = (code) => {
    triggerSaveByLabel(code);
    removeFormCode(code);

    if (showDashboardWorkQueue) {
      dispatch(
        postWqActivity({
          userWqAccount: location?.state?.accountNumber,
          userName: roleData?.userDetails?.userName,
          workQueueCode: workQueueListData?.workQueueName,
        }),
      );
    }
  };

  return { saveWindow };
};
